import { acPartners } from './partners'

const COOKIE_EXPIRES = 365
const SEPERATOR = '~'
const DOT = '.'
const VERSION = 1
const STORAGE_KEY = 'addtlConsent'

export class AC {

  public static get value () {
    const val = localStorage.getItem(STORAGE_KEY)

    return val
  }

  public static partners: Array<IPartners> = acPartners

  /** Parses existing AC string (if available) to a UI-consumable object */
  public static parseString(): IPartnerIds | null {
    if (AC.value) {
      const acceptedPartners = {}
      const acceptedPartnersArr = AC.value
        .split(`${VERSION}${SEPERATOR}`)[1]
        .split(DOT)
      acceptedPartnersArr.forEach((providerId) => {
        acceptedPartners[providerId] = true
      })
      return acceptedPartners
    }
    return null
  }

  /** Sets the AC String with all partners, creates/updates addtlConsent cookie */
  public static setAll(): void {
    const value = `${VERSION}${SEPERATOR}${AC.partners
      .map(({ providerId }) => providerId)
      .join(DOT)}`


    localStorage.setItem(STORAGE_KEY, value)
  }

  /** Sets the AC String with some selected partners, creates/updates addtlConsent cookie */
  public static setSome(somePartners: IPartnerIds): void {
    const selectPartnersArr = Object.keys(somePartners)
    const acceptedPartnersArr = selectPartnersArr.filter(
      (providerId) => somePartners[providerId]
    )
    const value = `${VERSION}${SEPERATOR}${acceptedPartnersArr.join(DOT)}`

    localStorage.setItem(STORAGE_KEY, value)
  }
}

interface IPartnerIds {
  [key: number]: boolean
}

interface IPartners {
  providerId: number
  providerName: string
  policyUrl: string
}
